import angular from 'angular';

angular.module('commonServices').service('appSettings', [
  'dataCache',
  function(dataCache) {
    var data = {
      defaultCountry: 'BE',
      defaultCurrency: 'EUR',
      tenantConfiguration: 0,
      relationListPageSize: 50,
      // dateOptions are currently not in use, but might be used again
      dateOptions: {
        dateFormat: 'd/m/yy',
        dayNamesMin: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
        monthNamesShort: [
          'Jan',
          'Feb',
          'Maa',
          'Apr',
          'Mei',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Okt',
          'Nov',
          'Dec',
        ],
        changeYear: true,
        changeMonth: true,
        onChangeMonthYear: function(year, month, datepickerInst) {
          var day = datepickerInst.selectedDay;
          $(this).datepicker('setDate', new Date(year, month - 1, day));
        },
        yearRange: '-80:+00',
      },
    };
    data.reload = function() {
      var company = dataCache.getDefaultCompany();
      data.defaultCountry = company.countryCode || 'BE';
      data.defaultCurrency = company.currencyCode;
      data.tenantConfiguration = dataCache.getArray('tenantConfiguration');
      data.defaultCompany = company.id;
    };
    dataCache.ready().then(data.reload);
    return data;
  },
]);
